/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CalendarTimeZone_profileTimeZone = {
    readonly timeZone: string;
    readonly userId: string | null;
    readonly calendarId: string | null;
    readonly " $refType": "CalendarTimeZone_profileTimeZone";
};
export type CalendarTimeZone_profileTimeZone$data = CalendarTimeZone_profileTimeZone;
export type CalendarTimeZone_profileTimeZone$key = {
    readonly " $data"?: CalendarTimeZone_profileTimeZone$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CalendarTimeZone_profileTimeZone">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTimeZone_profileTimeZone",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeZone",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calendarId",
            "storageKey": null
        }
    ],
    "type": "ProfileTimeZone",
    "abstractKey": null
} as any;
(node as any).hash = '081ac65dfda0343011c08e2143443e90';
export default node;
